// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collective[data-v-6821b942]{display:flex;flex-direction:column;padding:20px 0 0}.collective-toggle[data-v-6821b942]{padding:0 0 15px 5px}.collective-toggle label[data-v-6821b942]{color:var(--c-black);font-size:12px}.collective-toggle__tooltip[data-v-6821b942]{margin:0 0 0 5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
